import { $frontiersClibConfig } from "@frontiers-vue3/public-pages";
import { defineNuxtPlugin } from "nuxt/app";
import { useConfigurationStore } from "~/stores/configurationStore";

/**
 * This config is used for frontiers-vue3/public-pages library components
 */

export default defineNuxtPlugin(async () => {
    const isDevelopmentMode = process.env.NODE_ENV === "development";

    const configurationStore = useConfigurationStore();
    const configuration = configurationStore.config;
    const domainProperties = configuration?.domainProperties;
    if (!domainProperties) {
        return;
    }

    $frontiersClibConfig.setConfig({
        isFrontiers: domainProperties.domain.includes("frontiers"),
        tenantName: domainProperties.spaceName,
        mainDomain: domainProperties.domain,
        loopUrl: domainProperties.loopUrl,
        ssMainDomain: domainProperties.ssMainDomain,
        useWwwAbsoluteUrls: !isDevelopmentMode
    });
});
